export const calcHeight = (wind) => {

  let calcHeight = wind.height - 5*wind.rem;
  let containerWidth = wind.width - 2*wind.rem;
  
  if(calcHeight/containerWidth < .56 ){
    return wind.height - 5*wind.rem
  }else{
    return wind.width*.56
  }

}

export const externalLinks = (html) => {
  if (!html || typeof document === 'undefined') return html;

  const template = document.createElement('template');
  template.innerHTML = html;

  template.content.querySelectorAll('a[href]').forEach((a) => {
    let url;
    try {
      url = new URL(a.getAttribute('href'), window.location.href);
    } catch (e) {
      return;
    }
    if (!/^https?:$/.test(url.protocol) || url.host === window.location.host) return;

    a.setAttribute('target', '_blank');
    a.setAttribute('rel', 'noopener noreferrer');
  });

  return template.innerHTML;
}
